import React, { Component, useState } from 'react';

import './AddAnomaly.css';

import request from '@acri-tools/react-tools/utils/request';
import { API_URL } from '../../utils/config';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import Select from '@acri-tools/react-tools/components/Select/Select';
import SelectFilter from '@acri-tools/react-tools/components/SelectFilter/SelectFilter';
import { CSVReader } from 'react-papaparse';
import { connect } from 'react-redux';
import { setGeneral } from '../../redux/actions';
import InputListImages from '../../components/InputListImages/InputListImages';
import ImageUploading from 'react-images-uploading';


interface Props {
    history?: any,
    anomaly?: any,
    new_anomaly?: boolean
    onFinish?: any
    onAnomalyChange?: any
    general: any
    setGeneral?: Function
    mainPage?: boolean
    currentAnomaly?: any
    viewAnomaly?: any
}
interface State {
    anomaly: any
    button_value: String
    button_display: boolean
    div_display: boolean
    search_value: any
    isReset: boolean
    uploaded_images: any
    uploaded_images_show: any
    selectedFile: any
    compare: any
}

class AddAnomaly extends Component<Props, State>{
    res: any
    filtered_list = []

    constructor(props: Props) {
        super(props);

        this.state = {
            anomaly: this.props.mainPage ? JSON.parse(JSON.stringify(this.props.anomaly)) : {},
            button_value: "SHOW IMPACT LIST ITEMS",
            button_display: false,
            div_display: false,
            search_value: '',
            isReset: false,
            uploaded_images: [],
            uploaded_images_show: [],
            selectedFile: null,
            compare: JSON.stringify(this.props.anomaly),
        }
    }

    addAnomaly = async () => {

        let data = new FormData();

        if (this.state.uploaded_images) {
            for (let i = 0; i < this.state.uploaded_images.length; i++) {
                data.append(`file_${i}`, this.state.uploaded_images[i]);
            }
        }

        let date = new Date().toISOString();
        Object.keys(this.state.anomaly).forEach((attr: string) => {
            if (attr === 'impact_list' || attr === 'impact_list_data_type') {
                data.append(attr, JSON.stringify(this.state.anomaly[attr]));
            } else {
                data.append(attr, this.state.anomaly[attr]);
            }
        });
        data.append('creation_date_time', date);
        data.append('update_date_time', date);

        try {
            let res = await request(`${API_URL}/api/v1/anomalies/`, {
                method: 'post',
                data
            })
            create_toast({ type: 'success', message: `Successfully created anomaly` })
            this.resetCSVReader();
            this.props.onFinish();
            this.props.setGeneral?.({ modal_new_anomaly: false, updated: false });
            this.setState?.({ button_display: false, div_display: false, anomaly: {} });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `addAnomaly` });
            toast_request_error(e);
        }
        finally {
        }
    }

    modifyAnomaly = async () => {
        let current_anomaly = JSON.stringify(this.state.anomaly);

        if (this.state.compare === current_anomaly && this.state.uploaded_images.length === 0) {
            create_toast({ type: 'info', message: `Anomaly ${this.props.anomaly.id} is up to date` })
        } else {

            try {
                let { id } = this.props.anomaly;
                let anomaly = { ...this.state.anomaly };
                delete anomaly.id;

                for (const [key, value] of Object.entries(anomaly)) {
                    if (value === null) {
                        delete anomaly[key];
                    }
                }

                await this.setState({ anomaly });

                let data = new FormData();

                if (this.state.uploaded_images) {
                    for (let i = 0; i < this.state.uploaded_images.length; i++) {
                        data.append(`file_${i}`, this.state.uploaded_images[i]);
                    }
                }

                let date = new Date().toISOString();

                Object.keys(this.state.anomaly).forEach((attr: string) => {
                    if (attr === 'impact_list' || attr === 'impact_list_data_type' || attr === 'illustration') {
                        data.append(attr, JSON.stringify(this.state.anomaly[attr]));
                    } else if (attr === 'update_date_time') {
                        data.append('update_date_time', date);
                    } else {
                        data.append(attr, this.state.anomaly[attr]);
                    }
                });

                let res = await request(`${API_URL}/api/v1/anomalies/${id}`, {
                    method: 'put',
                    data
                })
                create_toast({ type: 'success', message: `Successfully updated anomaly ${id}` })
                this.props.setGeneral?.({ modal_update: false, updated: false, modal_open: false });
                this.resetCSVReader();
                this.props.onFinish();
                anomaly.id = this.props.anomaly?.id;
            }
            catch (e) {
                axiosErrorHandler(e, { functionName: `modifyAnomaly` });
                toast_request_error(e);
            }
            finally {

                // this.setState({ updating: false })
            }
        }
    }

    getAnomalyById = async (load?: boolean) => {
        // if (load) this.setState({ loading: true });

        try {
            this.res = await request(`${API_URL}/api/v1/anomalies/${this.props.anomaly.id}`, {
                method: 'get',
                params: {}
            })
            delete this.res.data.update_date_time;
            this.setState({ compare: JSON.stringify(this.res.data), anomaly: this.res.data });
            this.forceUpdate();
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `getAnomalies` });
            toast_request_error(e);
        }
        finally {
            // if (load) this.setState({ loading: false })
        }
    }

    // Clear Add Anomaly form
    clearFields = () => {
        this.resetCSVReader();
        this.setState({ anomaly: {}, button_display: false, div_display: false, uploaded_images_show: [] });
    }

    // Remove changes from Update Anomaly form
    removeChanges = () => {
        this.getAnomalyById();
        this.resetCSVReader();
        this.setState({ div_display: false, button_display: false, uploaded_images_show: [] });
    }

    // Set changes for Anomaly object
    updateAnomalyObject = (key: string, params: any) => {
        Object.assign(this.state?.anomaly, { [key]: params });
        this.props.setGeneral?.({ updated: true });
    }

    showModifyDiv = () => {
        if (!this.props.general.modal_open) {
            this.props.setGeneral?.({ modal_open: true });
        }
        this.resetCSVReader();
        this.props.setGeneral?.({ images: [], updated: false, modify_button: false, view_anomaly: false, modify_anomaly: true, hidden_button: true });
        this.setState({ anomaly: JSON.parse(JSON.stringify(this.props.anomaly)), button_display: false, div_display: false });
        this.forceUpdate();
    }

    closeUpdateModal = () => {
        if (this.state.isReset === true) {
            this.setState({ isReset: false });
        }
        this.props.onAnomalyChange(this.state.anomaly);
        this.props.setGeneral?.({ view_anomaly: true, updated: false, modify_button: true, modify_anomaly: false, hidden_button: false, anomaly: this.state.compare });
        this.setState({ button_display: false, div_display: false });
    }

    resetCSVReader = () => {
        this.state.isReset === true ? this.setState({ isReset: false }) : this.setState({ isReset: true });
    }

    // For CSV Reader
    handleOnDrop = (csv_impacts: any) => {
        let list = [];
        var i = 0;
        if (csv_impacts[0]?.data[0] === 'product_name') {
            i = 1;
        }
        for (i; i < csv_impacts.length - 1; i++) {
            list.push(csv_impacts[i].data[0]);
        }
        this.updateAnomalyObject('impact_list', list);
        this.setState({ button_value: "SHOW IMPACT LIST ITEMS", button_display: true, div_display: false });
    }

    // For CSV Reader
    handleOnRemoveFile = (data: any) => {
        this.updateAnomalyObject('impact_list', []);
        this.filtered_list = [];
        this.setState?.({ button_display: false, div_display: false });
    }

    // For CSV Reader
    showImpactListItems = () => {
        if (this.state.div_display === false) {
            this.setState({ button_value: "HIDE IMPACT LIST ITEMS", div_display: true });

        } else {
            this.setState({ button_value: "SHOW IMPACT LIST ITEMS", div_display: false });
        }
    }

    render() {
        return (
            <>
                {
                    this.props.general.modify_anomaly &&
                    <div key={this.props.anomaly} id="modify_anomaly" className="view-anomaly">
                        <div className="view-anomaly">
                            <div className="add-first-column">
                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Title:</div>
                                    <input
                                        className="custom-input"
                                        type="text"
                                        value={this.state.anomaly?.title ? this.state.anomaly?.title : ''}
                                        onChange={(title: any) => {
                                            this.updateAnomalyObject('title', title.target.value);
                                        }}
                                    />
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Status: </div>
                                    <Select
                                        nullable={true}
                                        value={this.state.anomaly?.status ? this.state.anomaly?.status : ''}
                                        options={['created', 'updated', 'deleted']
                                            .map((val) => { return { value: val, label: val } })}
                                        onChange={async (status: any) => {
                                            this.updateAnomalyObject('status', status);
                                        }}
                                    />
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Type: </div>
                                    <Select
                                        nullable={true}
                                        value={this.state.anomaly?.type ? this.state.anomaly?.type : ''}
                                        options={[
                                            'On-board anomaly',
                                            'Processing anomaly - L0',
                                            'Processing anomaly - L1B',
                                            'Processing anomaly - L1C',
                                            'Processing anomaly - L2A'
                                        ]
                                            .map((val) => { return { value: val, label: val } })}
                                        onChange={async (type: any) => {
                                            this.updateAnomalyObject('type', type);
                                        }}
                                    />
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Category: </div>
                                    <Select
                                        nullable={true}
                                        value={this.state.anomaly?.category ? this.state.anomaly?.category : ''}
                                        options={['recurrent', 'systematic']
                                            .map((val) => { return { value: val, label: val } })}
                                        onChange={async (category: any) => {
                                            this.updateAnomalyObject('category', category);
                                        }}
                                    />
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Severity: </div>
                                    <Select
                                        nullable={true}
                                        value={this.state.anomaly?.severity ? this.state.anomaly?.severity : ''}
                                        options={['minor', 'major']
                                            .map((val) => { return { value: val, label: val } })}
                                        onChange={async (severity: any) => {
                                            this.updateAnomalyObject('severity', severity);
                                        }}
                                    />
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">NRT status: </div>
                                    <Select
                                        nullable={true}
                                        value={this.state.anomaly?.nrt_status ? this.state.anomaly?.nrt_status : ''}
                                        options={['Under Investigation', 'To be fixed', 'Fixed', 'Not Applicable']
                                            .map((val) => { return { value: val, label: val } })}
                                        onChange={async (nrt_status: any) => {
                                            this.updateAnomalyObject('nrt_status', nrt_status);
                                        }}
                                    />
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Archive status: </div>
                                    <Select
                                        nullable={true}
                                        value={this.state.anomaly?.archive_status ? this.state.anomaly?.archive_status : ''}
                                        options={['Present', 'To be deleted', 'Deleted', 'Reprocessed']
                                            .map((val) => { return { value: val, label: val } })}
                                        onChange={async (archive_status: any) => {
                                            this.updateAnomalyObject('archive_status', archive_status);
                                        }}
                                    />
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Comment: </div>
                                    <textarea
                                        className=""
                                        rows={7}
                                        cols={23}
                                        value={this.state.anomaly?.comment ? this.state.anomaly?.comment : ''}
                                        onChange={(comment: any) => {
                                            this.updateAnomalyObject('comment', comment.target.value);
                                        }}
                                    />
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">URL: </div>
                                    <input
                                        className="custom-input"
                                        type="text"
                                        value={this.state.anomaly?.url ? this.state.anomaly?.url : ''}
                                        onChange={(url: any) => {
                                            this.updateAnomalyObject('url', url.target.value);
                                        }}
                                    />
                                </div>
                                <div className="anomaly-modal-parameters">

                                    <div className="anomaly-modal-parameter-title"> Impact List: </div>
                                    <CSVReader
                                        onDrop={this.handleOnDrop}
                                        addRemoveButton
                                        onRemoveFile={this.handleOnRemoveFile}
                                        isReset={this.state.isReset}
                                        progressBarColor={'rgb(21, 32, 57)'}
                                        style={{
                                            dropFile: { background: '#f5f5fc' },
                                            fileNameInfo: { 'max-width': '90px' },
                                            dropArea: { height: 'unset' },
                                        }}

                                    >
                                        <span>Drop your file here or click to upload</span>
                                    </CSVReader>
                                </div>

                                <div className="anomaly-modal-parameters" style={{ display: (this.state.button_display ? 'flex' : 'none') }}>
                                    <div className="impact-list-items">
                                        <button id="impact_items_button" className="" style={{ display: (this.state.button_display ? 'flex' : 'none') }} onClick={this.showImpactListItems}>{this.state.button_value}</button>
                                        <div id="impact_items_div" style={{ display: (this.state.div_display ? 'flex' : 'none') }} className="impact-tems-div">
                                            <div className="impacts-search">
                                                <i className="fa fa-search tr-search-icon icon-only" />
                                                <input
                                                    type="text"
                                                    name="search"
                                                    id="search"
                                                    placeholder="Search Items"
                                                    value={this.state.search_value ? this.state.search_value : ''}
                                                    onChange={(value: any) => {
                                                        this.setState({ search_value: value.target.value });
                                                        this.filtered_list = this.state.anomaly?.impact_list?.filter((impact: any) =>
                                                            impact.includes(value.target.value)
                                                        )
                                                    }}
                                                />
                                            </div>

                                            {this.state.search_value && this.state.search_value != '' && this.filtered_list != [] ?
                                                this.filtered_list?.map((impact_list: string, idx: any) => {
                                                    return <div key={idx} className="impact-item"> {impact_list} </div>
                                                })
                                                : this.state.anomaly?.impact_list ?
                                                    this.state.anomaly.impact_list?.map((impact_list: string, idx: any) => {
                                                        return <div key={idx} className="impact-item"> {impact_list} </div>
                                                    })
                                                    : null
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Impact List Type: </div>
                                    <div className="anomaly-list-types">
                                        <Select
                                            nullable={true}
                                            value={this.state.anomaly?.impact_list_type ? this.state.anomaly?.impact_list_type : ''}
                                            options={['exhaustive', 'partial']
                                                .map((val) => { return { value: val, label: val } })}
                                            onChange={async (impact_list_type: any) => {
                                                this.updateAnomalyObject('impact_list_type', impact_list_type);
                                            }}
                                        />
                                        <SelectFilter
                                            filters={['datatakes', 'datastrips', 'products']}
                                            values={this.state.anomaly?.impact_list_data_type ? this.state.anomaly?.impact_list_data_type : []}
                                            onChange={(impact_list_data_type) => {
                                                this.updateAnomalyObject('impact_list_data_type', impact_list_data_type);
                                            }}
                                        />

                                    </div>
                                </div>

                                <div className="anomaly-modal-parameters">
                                    <div className="anomaly-modal-parameter-title">Illustrations: </div>

                                    <div className="anomaly-image-input">
                                        <ImageUploading
                                            multiple
                                            value={this.state.uploaded_images_show}
                                            onChange={(imgs) => {
                                                this.props.setGeneral?.({ updated: true });
                                                let tab: any = [];
                                                if (imgs) {
                                                    imgs.forEach(element => {
                                                        tab.push(element.file)
                                                    });
                                                    this.setState({ uploaded_images: tab, uploaded_images_show: imgs });
                                                }
                                            }}
                                            maxNumber={10}
                                            dataURLKey="data_url"
                                        >
                                            {({
                                                imageList,
                                                onImageUpload,
                                                onImageRemoveAll,
                                                onImageUpdate,
                                                onImageRemove,
                                                isDragging,
                                                dragProps,
                                            }) => (
                                                    <div className="upload-image-wrapper">
                                                        <button
                                                            className="upload-image-button"
                                                            style={isDragging ? { borderColor: 'gray' } : undefined}
                                                            onClick={onImageUpload}
                                                            {...dragProps}
                                                        >
                                                            Drop your file here or click to upload
                                                            </button>
                                                            &nbsp;
                                                        <div className="uploaded-images-wrapper">
                                                            {imageList.map((image, index) =>
                                                                (
                                                                    <div key={index} className="image-item">
                                                                        <img className="uploaded-image-img" src={image['data_url']} alt="" width="100" />
                                                                        <div className="image-item-btn-wrapper">
                                                                            {/* <button onClick={() => onImageUpdate(index)}>Update</button> */}
                                                                            <button className="remove-image" onClick={() => onImageRemove(index)}>&times;</button>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                        </ImageUploading>

                                        {this.state.anomaly?.illustration ?
                                            <>
                                                <div id="hidden_images" >
                                                    <InputListImages
                                                        label={<><i className="fas fa-info" /> Images</>}
                                                        type="text"
                                                        values={this.state.anomaly.illustration}
                                                        onChange={(input_list_images) => {
                                                            let { anomaly } = this.state;
                                                            anomaly.illustration = input_list_images;
                                                            this.setState({ anomaly })
                                                        }}
                                                    />
                                                </div>
                                            </>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="add-modal-buttons">
                            {this.props.new_anomaly ?
                                <div className="anomaly-modal-buttons">
                                    <button id="clear_button" className="button-generic" onClick={this.clearFields}>CLEAR FIELDS</button>
                                </div>
                                :
                                <div className="anomaly-modal-buttons">
                                    <button id="remove_button" className="button-generic" onClick={this.removeChanges}>REMOVE CHANGES</button>
                                </div>
                            }
                            {this.props.new_anomaly ?
                                <div className="anomaly-modal-buttons">
                                    <button id="add_button" className="button-generic" onClick={this.addAnomaly}>ADD</button>
                                </div>
                                :
                                <div className="anomaly-modal-buttons">
                                    <button id="update_button" className="button-generic" onClick={this.modifyAnomaly}>UPDATE</button>
                                </div>
                            }
                        </div>

                    </div>
                }

                {!this.props.new_anomaly && this.props.general.modify_button &&
                    <div id="modify_button" className="anomaly-modal-buttons">
                        <button id="modif_button" className="button-generic" onClick={() => this.showModifyDiv()}>MODIFY</button>
                    </div>
                }
            </>
        );
    }

};

export default connect((state: any) => {
    return {
        general: state.general
    }
}, {
    setGeneral
})(AddAnomaly);